"use client";

// import Nav from "@/components/nav";
import Hero from "@/components/hero";
import Footer from "@/components/footer";
// import MainPopup from "@/components/main-popup";
import MainPopup2 from "@/components/main-popup-2";
import { useState } from "react";

export default function Home() {
  const [firstClosed, setFirstClosed] = useState(false);

  return (
    <div className="min-h-screen -mt-24 flex flex-col bg-black text-white">
      {/* <Nav /> */}
      <Hero />
      <Footer />
      {/* <MainPopup2 onClose={() => setFirstClosed(true)} /> */}
      {/* {firstClosed && <MainPopup />} */}
      {/* <MainPopup /> */}
    </div>
  );
}
